import { getRailsClient } from "sj-ui-toolkit/src/client";
import type { TimeSpentData, LessonCompletionData } from "../helpers/dashboard";

export interface LearningActivityStats {
  timeSpent: TimeSpentData;
  totalCompleted: LessonCompletionData;
}

export const fetchTimeSpentStats = async (): Promise<TimeSpentData> => {
  const API = `/api/internal_api/atlas/v1/admin/stats/time_spent`;
  const { data } = await getRailsClient().get<TimeSpentData>(API);
  return data;
};

export const fetchLessonCompletionStats = async (): Promise<LessonCompletionData> => {
  const API = `/api/internal_api/atlas/v1/admin/stats/lessons_completed`;
  const { data } = await getRailsClient().get<LessonCompletionData>(API);
  return data;
};

export const fetchLearningActivityStats = async (): Promise<LearningActivityStats> => {
  try {
    const timeSpentPromise = fetchTimeSpentStats();
    const totalCompletedPromise = fetchLessonCompletionStats();

    const [timeSpent, totalCompleted] = await Promise.all([
      timeSpentPromise,
      totalCompletedPromise,
    ]);

    return {
      timeSpent,
      totalCompleted,
    };
  } catch (error) {
    console.error("Error fetching learning activity stats:", error);
    throw error;
  }
};
